module.exports = __webpack_public_path__ + "media/images/mypage/icon/green-pale/ico_bell-5fac79e469e44e5dcd4e0bf5ebeab6d5.svg";